export default {
  methods: {
    requestFeedback() {
      this.$api.feedback.requestFeedback(this.data.id).then(() => {
        this.remindFeedback = false;
        this.notify(
          this.$bvToast,
          `Feedback request sent`,
          null,
          'success'
        );
      }).catch((error) => {
        this.notify(
          this.$bvToast,
          error.response.data.errors[0],
          null,
          'danger'
        );
      });
    },
    askFeedbackConfirmation(lead) {
      this.data = lead;
      this.$bvModal.show('feedback-confirmation');
    }
  },
};
